.workExperience {
  padding: 8rem 0rem 10rem 0rem;
  background-image: radial-gradient(
    50% 50% at 50% 50%,
    #763cac 0%,
    rgba(50, 15, 133, 0) 100%
  );
  background-position: center 3.125rem;
  background-size: 39.063rem 43.75rem;
  background-repeat: no-repeat;
  overflow: visible;
  max-width: 72.25rem;

  ul {
    display: grid;
    margin-top: 3rem;

    flex-wrap: wrap;
    grid-template-columns: repeat(2, 35.624rem);
    gap: 1rem;
    row-gap: 1rem;

    justify-content: center;
    list-style: none;

    font-family: Inter, Arial;
    li {
      position: relative;
      display: flex;
      flex-direction: row;

      overflow: hidden;

      background-color: #693b93;
      border-radius: 15px;
      width: 35.625rem;
      height: 12.043rem;

      .card {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 2rem;

        position: absolute;
        height: 98%;
        width: 100%;
        top: 2%;
        background: linear-gradient(
          110.49deg,
          #130428 19.95%,
          #251043 67.64%,
          #38126d 107.08%,
          #261045 156.61%,
          #190634 183.21%
        );
        img {
          align-self: center;
          position: inline;
          width: fit-content;
          height: fit-content;

          height: 7.625rem;

          float: left;
        }

        .text {
          align-self: center;
          vertical-align: middle;
          position: relative;

          width: 13.5rem;
          float: right;
          h2 {
            white-space: nowrap;
            font-style: normal;
            font-weight: 600;
            font-size: 1.625rem;
            line-height: 2rem;
          }
          h5 {
            margin-top: 0.688rem;

            font-style: normal;
            font-weight: 500;
            font-size: 0.5rem;
            line-height: 0.625rem;
          }
          a {
            margin-top: 0.688rem;
            display: flex;

            position: relative;
            text-decoration: none;
            background-color: #2c1250;

            height: 2.5rem;
            width: 9rem;
            border: 1px solid #693b93;
            border-radius: 0.625rem;

            color: #fff;

            align-items: center;
            justify-content: center;

            text-transform: uppercase;
            font-weight: 500;
            font-size: 0.625rem;
            line-height: 0.938rem;
          }
        }
      }
    }
  }
}
